import React from "react";
import cn from "classnames";

const IconUser = () => (
  <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.75 7C14.75 5.6875 14 4.46875 12.875 3.76562C11.7031 3.10938 10.25 3.10938 9.125 3.76562C7.95312 4.46875 7.25 5.6875 7.25 7C7.25 8.35938 7.95312 9.57812 9.125 10.2812C10.25 10.9375 11.7031 10.9375 12.875 10.2812C14 9.57812 14.75 8.35938 14.75 7ZM5 7C5 4.89062 6.125 2.92188 8 1.84375C9.82812 0.765625 12.125 0.765625 14 1.84375C15.8281 2.92188 17 4.89062 17 7C17 9.15625 15.8281 11.125 14 12.2031C12.125 13.2812 9.82812 13.2812 8 12.2031C6.125 11.125 5 9.15625 5 7ZM2.79688 22.75H19.1562C18.7344 19.7969 16.2031 17.5 13.1094 17.5H8.84375C5.75 17.5 3.21875 19.7969 2.79688 22.75ZM0.5 23.6406C0.5 19 4.20312 15.25 8.84375 15.25H13.1094C17.75 15.25 21.5 19 21.5 23.6406C21.5 24.3906 20.8438 25 20.0938 25H1.85938C1.10938 25 0.5 24.3906 0.5 23.6406Z"
      fill="#0077C0"
    />
  </svg>
);

const IconBuildings = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 2.25H13.5C13.0781 2.25 12.75 2.625 12.75 3V21C12.75 21.4219 13.0781 21.75 13.5 21.75H21C21.375 21.75 21.75 21.4219 21.75 21V3C21.75 2.625 21.375 2.25 21 2.25ZM13.5 0H21C22.6406 0 24 1.35938 24 3V21C24 22.6875 22.6406 24 21 24H13.5C11.8125 24 10.5 22.6875 10.5 21V3C10.5 1.35938 11.8125 0 13.5 0ZM9 6V8.25H3.375C2.71875 8.25 2.25 8.76562 2.25 9.375V20.625C2.25 21.2812 2.71875 21.75 3.375 21.75H9.04688C9.1875 22.6406 9.5625 23.3906 10.125 24H3.375C1.5 24 0 22.5 0 20.625V9.375C0 7.54688 1.5 6 3.375 6H9ZM5.25 15H6.75C7.125 15 7.5 15.375 7.5 15.75V17.25C7.5 17.6719 7.125 18 6.75 18H5.25C4.82812 18 4.5 17.6719 4.5 17.25V15.75C4.5 15.375 4.82812 15 5.25 15ZM15.75 15.75V14.25C15.75 13.875 16.0781 13.5 16.5 13.5H18C18.375 13.5 18.75 13.875 18.75 14.25V15.75C18.75 16.1719 18.375 16.5 18 16.5H16.5C16.0781 16.5 15.75 16.1719 15.75 15.75ZM5.25 10.5H6.75C7.125 10.5 7.5 10.875 7.5 11.25V12.75C7.5 13.1719 7.125 13.5 6.75 13.5H5.25C4.82812 13.5 4.5 13.1719 4.5 12.75V11.25C4.5 10.875 4.82812 10.5 5.25 10.5ZM15.75 5.25C15.75 4.875 16.0781 4.5 16.5 4.5H18C18.375 4.5 18.75 4.875 18.75 5.25V6.75C18.75 7.17188 18.375 7.5 18 7.5H16.5C16.0781 7.5 15.75 7.17188 15.75 6.75V5.25ZM16.5 12C16.0781 12 15.75 11.6719 15.75 11.25V9.75C15.75 9.375 16.0781 9 16.5 9H18C18.375 9 18.75 9.375 18.75 9.75V11.25C18.75 11.6719 18.375 12 18 12H16.5Z"
      fill="#0077C0"
    />
  </svg>
);

const IconUnchecked = () => (
  <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.75 13C21.75 9.53125 19.875 6.34375 16.875 4.5625C13.8281 2.82812 10.125 2.82812 7.125 4.5625C4.07812 6.34375 2.25 9.53125 2.25 13C2.25 16.5156 4.07812 19.7031 7.125 21.4844C10.125 23.2188 13.8281 23.2188 16.875 21.4844C19.875 19.7031 21.75 16.5156 21.75 13ZM0 13C0 8.73438 2.25 4.79688 6 2.64062C9.70312 0.484375 14.25 0.484375 18 2.64062C21.7031 4.79688 24 8.73438 24 13C24 17.3125 21.7031 21.25 18 23.4062C14.25 25.5625 9.70312 25.5625 6 23.4062C2.25 21.25 0 17.3125 0 13Z"
      fill="#0077C0"
    />
  </svg>
);

const IconChecked = () => (
  <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 24C8.6875 24 4.75 21.75 2.59375 18C0.4375 14.2969 0.4375 9.75 2.59375 6C4.75 2.29688 8.6875 0 13 0C17.2656 0 21.2031 2.29688 23.3594 6C25.5156 9.75 25.5156 14.2969 23.3594 18C21.2031 21.75 17.2656 24 13 24ZM18.2969 9.79688H18.25C18.7188 9.375 18.7188 8.67188 18.25 8.20312C17.8281 7.78125 17.125 7.78125 16.7031 8.20312L11.5 13.4531L9.29688 11.25C8.82812 10.7812 8.125 10.7812 7.70312 11.25C7.23438 11.6719 7.23438 12.375 7.70312 12.7969L10.7031 15.7969C11.125 16.2656 11.8281 16.2656 12.2969 15.7969L18.2969 9.79688Z"
      fill="#0077C0"
    />
  </svg>
);

export const Radio = ({
  value = "radio-value",
  icon,
  name,
  isSmall = false,
  checked = false,
  isChecked,
  register = (e) => console.log(e),
  ...props
}) => {
  return (
    <>
      <input
        type="radio"
        id={value}
        value={value}
        className="peer w-0 h-0 invisible hidden"
        {...register(name)}
        {...props}
      />
      <label
        htmlFor={value}
        className={cn(
          "p-4 rounded-lg outline outline-1 outline-gray-modern-300 w-full h-[180px] lg:h-[160px] flex flex-col items-center lg:justify-center hover:outline-primary-500 transition peer-checked:outline-primary-500 peer-checked:outline-2 gap-3",
          {
            "justify-center": !isSmall,
            "max-lg:h-auto max-lg:flex-row !lg-max:justify-start": isSmall,
            "outline-primary-500 outline-2": checked,
            "outline-gray-modern-300 text-gray-modern-300 opacity-50 !hover:outline-gray-modern-300":
              props.disabled,
          }
        )}
      >
        {isSmall && (
          <div className="lg:hidden">{isChecked ? <IconChecked /> : <IconUnchecked />}</div>
        )}
        {icon === "user" ? <IconUser /> : <IconBuildings />}
        <p className="text-center font-semibold text-text-lg lg:text-text-md">{props.label}</p>
      </label>
    </>
  );
};
